export const countriesNo = {
  AF: 'Afganistan',
  AX: 'Åland',
  AL: 'Albania',
  DZ: 'Algerie',
  AS: 'Amerikansk Samoa',
  AD: 'Andorra',
  AO: 'Angola',
  AI: 'Anguilla',
  AQ: 'Antarktis',
  AG: 'Antigua og Barbuda',
  AR: 'Argentina',
  AM: 'Armenia',
  AW: 'Aruba',
  AU: 'Australia',
  AT: 'Østerike',
  AZ: 'Aserbajdsjan',
  BS: 'Bahamas',
  BH: 'Bahrain',
  BD: 'Bangladesh',
  BB: 'Barbados',
  BY: 'Belarus',
  BE: 'Belgia',
  BZ: 'Belize',
  BJ: 'Benin',
  BM: 'Bermuda',
  BT: 'Bhutan',
  BO: 'Bolivia',
  BA: 'Bosnia-Hercegovina',
  BW: 'Botswana',
  BV: 'Bouvetøya',
  BR: 'Brasil',
  IO: 'British Indian Ocean Territory',
  BN: 'Brunei',
  BG: 'Bulgaria',
  BF: 'Burkina Faso',
  BI: 'Burundi',
  KH: 'Kambodsja',
  CM: 'Kamerun',
  CA: 'Canada',
  CV: 'Kapp Verde',
  KY: 'Caymanøyene',
  CF: 'Den sentralafrikanske republikk',
  TD: 'Tsjad',
  CL: 'Chile',
  CN: 'Kina',
  CX: 'Kiritimati',
  CC: 'Kokosøyene',
  CO: 'Colombia',
  KM: 'Komorene',
  CG: 'Republikken Kongo',
  CD: 'Den demokratiske republikken Kongo',
  CK: 'Cookøyene',
  CR: 'Costa Rica',
  CI: 'Elfenbenskysten',
  HR: 'Kroatia',
  CU: 'Cuba',
  CY: 'Kypros',
  CZ: 'Tsjekkia',
  DK: 'Danmark',
  DJ: 'Djibouti',
  DM: 'Dominica',
  DO: 'Den dominikanske republikk',
  EC: 'Ecuador',
  EG: 'Egypt',
  SV: 'El Salvador',
  GQ: 'Ekvatorial-Guinea',
  ER: 'Eritrea',
  EE: 'Estland',
  ET: 'Etiopia',
  FK: 'Falklandsøyene',
  FO: 'Færøyene',
  FJ: 'Fiji',
  FI: 'Finland',
  FR: 'Frankrike',
  GF: 'Fransk Guyana',
  PF: 'Fransk Polynesia',
  TF: 'Franske Sydlige og Antarktiske Territorier',
  GA: 'Gabon',
  GM: 'Gambia',
  GE: 'Georgia',
  DE: 'Tyskland',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GR: 'Hellas',
  GL: 'Grønland',
  GD: 'Grenada',
  GP: 'Guadeloupe',
  GU: 'Guam',
  GT: 'Guatemala',
  GG: 'Guernsey',
  GN: 'Guinea',
  GW: 'Guinea-Bissau',
  GY: 'Guyana',
  HT: 'Haiti',
  HM: 'Heard- og McDonaldøyene',
  VA: 'Vatikanstaten',
  HN: 'Honduras',
  HK: 'Hong Kong',
  HU: 'Ungarn',
  IS: 'Island',
  IN: 'India',
  ID: 'Indonesia',
  IR: 'Iran',
  IQ: 'Irak',
  IE: 'Irland',
  IM: 'Isle of Man',
  IL: 'Israel',
  IT: 'Italia',
  JM: 'Jamaica',
  JP: 'Japan',
  JE: 'Jersey',
  JO: 'Jordan',
  KZ: 'Kasakhstan',
  KE: 'Kenya',
  KI: 'Kiribati',
  KR: 'Sør-Korea',
  KW: 'Kuwait',
  KG: 'Kirgisistan',
  LA: 'Laos',
  LV: 'Latvia',
  LB: 'Libanon',
  LS: 'Lesotho',
  LR: 'Liberia',
  LY: 'Libya',
  LI: 'Liechtenstein',
  LT: 'Litauen',
  LU: 'Luxembourg',
  MO: 'Macao',
  MK: 'Makedonia',
  MG: 'Madagaskar',
  MW: 'Malawi',
  MY: 'Malaysia',
  MV: 'Maldivene',
  ML: 'Mali',
  MT: 'Malta',
  MH: 'Marshalløyene',
  MQ: 'Martinique',
  MR: 'Mauritania',
  MU: 'Mauritius',
  YT: 'Mayotte',
  MX: 'Mexico',
  FM: 'Mikronesia',
  MD: 'Moldova',
  MC: 'Monaco',
  MN: 'Mongolia',
  ME: 'Montenegro',
  MS: 'Montserrat',
  MA: 'Marokko',
  MZ: 'Mosambik',
  MM: 'Myanmar',
  NA: 'Namibia',
  NR: 'Nauru',
  NP: 'Nepal',
  NL: 'Nederland',
  AN: 'AN',
  NC: 'Ny-Caledonia',
  NZ: 'New Zealand',
  NI: 'Nicaragua',
  NE: 'Niger',
  NG: 'Nigeria',
  NU: 'Niue',
  NF: 'Norfolkøya',
  MP: 'Nord-Marianene',
  NO: 'Norge',
  OM: 'Oman',
  PK: 'Pakistan',
  PW: 'Palau',
  PS: 'Palestina',
  PA: 'Panama',
  PG: 'Papua Ny-Guinea',
  PY: 'Paraguay',
  PE: 'Peru',
  PH: 'Filippinene',
  PN: 'Pitcairn',
  PL: 'Polen',
  PT: 'Portugal',
  PR: 'Puerto Rico',
  QA: 'Qatar',
  RE: 'Réunion',
  RO: 'Romania',
  RU: 'Russland',
  RW: 'Rwanda',
  BL: 'Saint-Barthélemy',
  SH: 'Sankt Helena, Ascension og Tristan da Cunha',
  KN: 'St. Kitts og Nevis',
  LC: 'St. Lucia',
  MF: 'Saint-Martin (Fransk)',
  PM: 'Saint-Pierre-et-Miquelon',
  VC: 'St. Vincent og Grenadinene',
  WS: 'Samoa',
  SM: 'San Marino',
  ST: 'São Tomé og Príncipe',
  SA: 'Saudi-Arabia',
  SN: 'Senegal',
  RS: 'Serbia',
  SC: 'Seychellene',
  SL: 'Sierra Leone',
  SG: 'Singapore',
  SK: 'Slovakia',
  SI: 'Slovenia',
  SB: 'Salomonøyene',
  SO: 'Somalia',
  ZA: 'Sør-Afrika',
  GS: 'Sør-Georgia og Sør-Sandwichøyene',
  ES: 'Spania',
  LK: 'Sri Lanka',
  SD: 'Sudan',
  SR: 'Surinam',
  SJ: 'Svalbard og Jan Mayen',
  SZ: 'Eswatini',
  SE: 'Sverige',
  CH: 'Sveits',
  SY: 'Syria',
  TW: 'Taiwan',
  TJ: 'Tadsjikistan',
  TZ: 'Tanzania',
  TH: 'Thailand',
  TL: 'Øst-Timor',
  TG: 'Togo',
  TK: 'Tokelau',
  TT: 'Trinidad og Tobago',
  TN: 'Tunisia',
  TR: 'Tyrkia',
  TM: 'Turkmenistan',
  TC: 'Turks- og Caicosøyene',
  TV: 'Tuvalu',
  UG: 'Uganda',
  UA: 'Ukraina',
  AE: 'De forente arabiske emirater',
  GB: 'Storbritannia',
  US: 'USA',
  UM: 'USAs ytre småøyer',
  UY: 'Uruguay',
  UZ: 'Usbekistan',
  VU: 'Vanuatu',
  VE: 'Venezuela',
  VN: 'Vietnam',
  VG: 'De britiske Jomfruøyer',
  VI: 'De amerikanske Jomfuøyer',
  WF: 'Wallis- og Futunaøyene',
  EH: 'Vest-Sahara',
  YE: 'Jemen',
  ZM: 'Zambia',
  ZW: 'Zimbabwe',
  BQ: 'Bonaire, Sint Eustatius og Saba',
  CW: 'Curacao',
  KP: 'Nord-Korea',
  SS: 'Sør-Sudan',
  SX: 'Sint Maarten (Nederland)',
  TO: 'Tonga',
  XK: 'Kosovo',
} as const;
